/**
 * @generated SignedSource<<89a3681fce28bf93201023b2e03933ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef$data = {
  readonly fieldsById?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldId?: string;
        readonly status?: {
          readonly statusCategory: {
            readonly statusCategoryId: string;
          } | null | undefined;
        };
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly isResolved: boolean | null | undefined;
  readonly statusField?: {
    readonly fieldId: string;
    readonly status: {
      readonly statusCategory: {
        readonly statusCategoryId: string;
      } | null | undefined;
    };
  } | null | undefined;
  readonly " $fragmentType": "issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef";
};
export type issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef$key = {
  readonly " $data"?: issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "fieldId"
  },
  {
    "concreteType": "JiraStatus",
    "kind": "LinkedField",
    "name": "status",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "statusCategoryId"
          }
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldsByIdRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isResolved"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraStatusField",
          "kind": "LinkedField",
          "name": "statusField",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "ids",
              "value": [
                "status"
              ]
            }
          ],
          "concreteType": "JiraIssueFieldConnection",
          "kind": "LinkedField",
          "name": "fieldsById",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueFieldEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "JiraStatusField"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "fieldsById(ids:[\"status\"])"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};
})();

(node as any).hash = "7f6c5f7e3145fad95a220ddab9110efe";

export default node;
